import { render, staticRenderFns } from "./EncodingList.vue?vue&type=template&id=53d82244&scoped=true"
import script from "./EncodingList.vue?vue&type=script&lang=js"
export * from "./EncodingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d82244",
  null
  
)

export default component.exports